// import 'bootstrap';
// import 'mdbootstrap';
// import 'bootstrap/dist/css/bootstrap.min.css';
// import 'mdbootstrap/css/mdb.min.css';
global.jQuery = require('jquery');
global.$ = global.jQuery;

import * as core from '../libs/tech.core'
import * as course from '../libs/tech.course'
import * as lazyLoad from '../libs/tech.lazy-load'
import * as phone from '../libs/tech.phone'
import * as captchaV3 from '../libs/tech.captchaV3'

$(function () {
    lazyLoad.initLazyLoad('.swiper-container');
    lazyLoad.initLazyLoad('.lazyBackground');
    lazyLoad.initLazyLoad('.anim-trigger', false, -70);
})

//more imports here

export {core, course, lazyLoad, phone, captchaV3}
